import React from 'react';

class SourceBoxTd extends React.Component {
  textMaxLength = 30;

  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({
      show: !this.state.show
    });
  }

  render() {
    const text = this.props.children,
      mustHide = this.props.hideLarge && text.slice && text.length > this.textMaxLength,
      className = mustHide ? 'country-profile-sourcebox__cell--clickable' : '';

    return (
      <td onClick={ mustHide ? this.handleClick : null } className={ className }>
        { mustHide && !this.state.show
          ? `${ text.slice(0, this.textMaxLength) }...`
          : text
        }
      </td>
    );
  }
}

export default SourceBoxTd;



// WEBPACK FOOTER //
// ./src/components/SourceBox/Table/Td.js